import axios from '@/libs/api.request'

// 获取上传配置列表
export const getUploadConfigList = (config_name, related_table, page = 1, limit = 100) => {
  return axios.request({
    url: '/v1/sysparameter/upload_config/',
    method: 'get',
    params: {
      config_name,
      related_table,
      page,
      limit
    }
  })
}

// 操作上传配置（新增或修改）
export const operationUploadConfig = (data, method = 'post') => {
  return axios.request({
    url: '/v1/sysparameter/upload_config/',
    method: method,
    data
  })
}

// 删除上传配置
export const deleteUploadConfig = (data) => {
  return axios.request({
    url: '/v1/sysparameter/upload_config/',
    method: 'delete',
    data
  })
}

// 获取单个上传配置详情
export const getUploadConfigDetail = (id) => {
  return axios.request({
    url: `/v1/sysparameter/upload_config/${id}`,
    method: 'get'
  })
}
